import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/spares")({
  component: () => (
    <RouteGuard module="spares" permission={["view_store_items"]}><Outlet /></RouteGuard>
  ),
});
